// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"16":"9f517f34","41":"8a1d314c","304":"39a35711","489":"90d657e4","615":"8a1d314c","709":"7d3b8e76","754":"8a1d314c","764":"4ff46db3"}[chunkId] + ".chunk.css";
};